const environmentKey = "makhazin-environment";
const appVersionKey = "makhazin-version";
export var Environment;
(function (Environment) {
    Environment["TEST"] = "TEST";
    Environment["LOCAL"] = "LOCAL";
})(Environment || (Environment = {}));
/** Sets environment. Defaults to LOCAL if no env is provided */
export const initEnvironment = (env) => {
    const environment = env ? Environment[env] : Environment.LOCAL;
    window[environmentKey] = environment;
};
export const setEnvironment = () => {
    const path = window.myPagesComponentPath.pluginsUrl; // this url is placed on the windows object by my-pages-component-plugin.php
    return fetch(`${path}/my-pages-component/appConfig.json`)
        .then(response => response.json())
        .then(config => {
        const env = (config.appConfig && config.appConfig.environment);
        initEnvironment(env);
    })
        .catch(() => {
        initEnvironment('LOCAL');
    });
};
export const getEnvironment = () => {
    return Environment[window[environmentKey]];
};
export const setAppVersion = (version) => {
    window[appVersionKey] = version;
};
export const getAppVersion = () => {
    return window[appVersionKey];
};
